import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 md:mr-8" }

import ParagraphTitle from "@/components/molecules/paragraphTitle/ParagraphTitle.vue";
import SuggestionTool from "@/components/organisms/suggestionTool/SuggestionTool.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ParagraphTitle, {
      size: "large",
      title: "Hola de nuevo 😊",
      message: "Contanos que herramienta te serviría, algún error o mejora que harías, y pronto tendrás novedades."
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SuggestionTool)
    ])
  ], 64))
}
}

})